import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["location", "kind", "station", "packing", "unavailable"]

  connect() {
    this.stations = Array.from(this.stationTarget.options, option => option.cloneNode(true))
    this.update()
  }

  update() {
    const location = this.locationTarget.value
    const selected = this.stationTarget.value
    const options = this.stations.filter(option => !option.value || option.dataset.locationId === location)
    this.stationTarget.replaceChildren(...options.map(option => option.cloneNode(true)))
    this.stationTarget.value = options.some(option => option.value === selected) ? selected : ""
    const packing = this.kindTarget.value === "pack"
    this.packingTarget.hidden = !packing
    this.stationTarget.disabled = !packing
    this.stationTarget.required = packing
    this.unavailableTarget.hidden = !packing || options.length > 1
    if (window.$) window.$(this.stationTarget).trigger("change.select2")
  }
}
